import types from './types';

export default {
    [types.ancientOffer]({
        commit
    }, value) {
        commit(types.ancientOffer, value);
    }
};
